export const P = (props) => {
    return (
        <p style={props.style}>{props.children}</p>
    )
}